import { render, staticRenderFns } from "./detailModalRef.vue?vue&type=template&id=276b5eb6&scoped=true&"
import script from "./detailModalRef.vue?vue&type=script&lang=js&"
export * from "./detailModalRef.vue?vue&type=script&lang=js&"
import style0 from "./detailModalRef.vue?vue&type=style&index=0&id=276b5eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276b5eb6",
  null
  
)

export default component.exports